.header {
  margin-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.75;
  text-transform: uppercase;
  color: #757575;
}

.filterItem {
  padding: 8px 0;
}
